import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL

export const get = async (queryParam, filters) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: filters || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/customer-contract`,
    params,
  })

  return response?.data
}

export const getWithFilters = (filters) => async (queryParam) => await get(queryParam, filters)

export const getDetail = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/customer-contract/${id}`,
  })

  return response?.data
}

export const store = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/customer-contract`,
    data
  })

  return response?.data
}

export const update = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: `/customer-contract/${id}`,
    data,
  })

  return response?.data
}

export const transition = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `customer-contract/${id}/transition`,
    data,
  })
  
  return response?.data
}

export const renewal = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `customer-contract/${id}/renewal`,
    data,
  })
  
  return response?.data
}

export const getCustomerContractHistory = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/customer-contract/${id}/history`
  })

  return response?.data
}

export const getListAttachment = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/customer-contract/${id}/attachment`
  })

  return response?.data
}

export const uploadAttachment = async (id, data) => {
  const formData = new FormData()
  for (const [key, value] of Object.entries(data)) {
    formData.append(key, value)
  }

  const response = await apiClientV2.put( `/customer-contract/${id}/attachment`, formData, {
    baseURL,
    method: 'PUT',
    headers: { 'Content-Type': 'multipart/form-data' },
  })

  return response?.data
}

export const deleteAttachment = async (contracId, attachmentId) => {
  const response = await apiClientV2({
    baseURL,
    method: 'DELETE',
    url: `/customer-contract/${contracId}/attachment/${attachmentId}`,
  })

  return response?.data
}

export const getListVehicle = async (id, queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    search: queryParam?.search || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/customer-contract/${id}/vehicle`,
    params,
  })

  return response?.data
}

export const showVehicle = async (contractId, vehicleId) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/customer-contract/${contractId}/vehicle/${vehicleId}`,
  })

  return response?.data
}

export const storeVehicle = async (contractId, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/customer-contract/${contractId}/vehicle`,
    data,
  })

  return response?.data
}

export const updateVehicle = async (contractId, vehicleId, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: `/customer-contract/${contractId}/vehicle/${vehicleId}`,
    data,
  })

  return response?.data
}

export const deleteVehicle = async (contractId, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'DELETE',
    url: `/customer-contract/${contractId}/vehicle`,
    data,
  })

  return response?.data
}

export const getCustomerContractVehicleHistory = async (contractId, vehicleId) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/customer-contract/${contractId}/vehicle/${vehicleId}/history`
  })

  return response?.data
}